import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.values.js";
import { useBrandArticlesByNode } from "./useBrandArticlesByNode";
import { useLoggedOutBrandNodes } from "./useLoggedOutBrandNodes";
export var useLoggedOutBrandNodesL1 = function useLoggedOutBrandNodesL1() {
  var loggedOutBrandNodes = useLoggedOutBrandNodes();
  return Object.values(loggedOutBrandNodes.L1).map(function (issue) {
    return {
      label: issue,
      value: issue
    };
  });
};
export var useLoggedOutBrandNodesL2 = function useLoggedOutBrandNodesL2() {
  var loggedOutBrandNodes = useLoggedOutBrandNodes();
  return Object.values(loggedOutBrandNodes.L2).map(function (issue) {
    return {
      label: issue,
      value: issue
    };
  });
};
export var useLoggedOutBrandNodesL3BySwf = function useLoggedOutBrandNodesL3BySwf() {
  var _useBrandArticlesByNo = useBrandArticlesByNode(),
    articlesByBrandSwf = _useBrandArticlesByNo.articlesByBrandSwf;
  return Object.keys(articlesByBrandSwf).map(function (issue) {
    return {
      label: issue,
      value: issue
    };
  });
};
export var useLoggedOutBrandNodesL3BySoyo = function useLoggedOutBrandNodesL3BySoyo() {
  var _useBrandArticlesByNo2 = useBrandArticlesByNode(),
    articlesByBrandSoyo = _useBrandArticlesByNo2.articlesByBrandSoyo;
  return Object.keys(articlesByBrandSoyo).map(function (issue) {
    return {
      label: issue,
      value: issue
    };
  });
};